import { z } from "zod";
export const horizonSeverityDtoSchema = z.enum(["error", "warning"]);
export const horizonIssueTypeDtoSchema = z.enum([
    "OutdatedHorizonVersion",
    "HorizonServicesNotRunning",
    "DBCCCheckFailure",
    "DatabaseSizeOverThreshold",
]);
//# sourceMappingURL=common.schema.js.map